<template>
  <div>
    <div class="columns">
      <div class="column">
        <h2 class="title is-3">Отправка оповещений</h2>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <b-tabs expanded type="is-toggle">
          <b-tab-item expanded label="SMS" icon="message">
            <div class="columns">
              <div class="column">
                <b-field label="Время отправки">
                  <b-datetimepicker
                    v-model="settings.sms.planned_at"
                    placeholder="Выбрать время"
                  >
                    <template slot="left">
                      <button
                        class="button is-primary"
                        @click="settings.sms.planned_at = new Date()"
                      >
                        <b-icon icon="clock"></b-icon>
                        <span>Now</span>
                      </button>
                    </template>
                    <template slot="right">
                      <button
                        class="button is-danger"
                        @click="settings.sms.planned_at = null"
                      >
                        <b-icon icon="close"></b-icon>
                        <span>Clear</span>
                      </button>
                    </template>
                  </b-datetimepicker>
                </b-field>
              </div>
              <div class="column">
                <b-field label="Метка рассылки">
                  <b-input v-model="settings.sms.source"></b-input>
                </b-field>
              </div>
            </div>
            <div class="columns">
                <div class="column is-6">
                    <b-field label="Шаблон">
                        <b-autocomplete
                          v-model="settings.sms.notification_template.name"
                          clearable
                          :data="filteredDataArray(this.templates, settings.sms.notification_template, 'sms')"
                          :keep-first="false"
                          :open-on-focus="true"
                          field="name"
                          @select="option => (option ? settings.sms.notification_template = option: settings.sms.notification_template = {name: ''})">
                          <template #empty> Нет результатов </template>
                        </b-autocomplete>
                    </b-field>
                </div>
            </div>

            <div class="columns">
              <div class="column">
                <b-button
                  type="is-primary"
                  class="is-pulled-right"
                  icon-left="plus"
                  @click="createModal('sms')"
                  >Cоздать уведомление</b-button
                >
              </div>
            </div>
          </b-tab-item>
          <b-tab-item expanded label="Call" icon="phone">
            <div class="columns">
              <div class="column">
                <b-field label="Время отправки">
                  <b-datetimepicker
                    v-model="settings.call.planned_at"
                    placeholder="Выбрать время"
                  >
                    <template slot="left">
                      <button
                        class="button is-primary"
                        @click="settings.call.planned_at = new Date()"
                      >
                        <b-icon icon="clock"></b-icon>
                        <span>Now</span>
                      </button>
                    </template>
                    <template slot="right">
                      <button
                        class="button is-danger"
                        @click="settings.call.planned_at = null"
                      >
                        <b-icon icon="close"></b-icon>
                        <span>Clear</span>
                      </button>
                    </template>
                  </b-datetimepicker>
                </b-field>
              </div>
              <div class="column">
                <b-field label="Метка рассылки">
                  <b-input v-model="settings.call.source"></b-input>
                </b-field>
              </div>
            </div>
            <div class="columns">
                <div class="column is-6">
                    <b-field label="Шаблон">
                        <b-autocomplete
                          v-model="settings.call.notification_template.name"
                          clearable
                          :data="filteredDataArray(this.templates, settings.call.notification_template, 'call')"
                          :keep-first="false"
                          :open-on-focus="true"
                          field="name"
                          @select="option => (option ? settings.call.notification_template = option: settings.call.notification_template = {name: ''})">
                          <template #empty> Нет результатов </template>
                        </b-autocomplete>
                    </b-field>
                </div>
            </div>
            <div class="columns">
              <div class="column">
                <b-button
                  type="is-primary"
                  class="is-pulled-right"
                  icon-left="plus"
                  @click="createModal('call')"
                  >Cоздать уведомление</b-button
                >
              </div>
            </div>
          </b-tab-item>
        </b-tabs>
      </div>
    </div>
    <CreateNotifications v-bind:params="props"></CreateNotifications>
    <CreateTemplate></CreateTemplate>
  </div>
</template>

<script>
import CreateNotifications from "../shared/modals/createNotifications";
import CreateTemplate from "../../notification_templates/modals/createTemplate.vue";

export default {
  name: "InstantNotifications",
  components: {
    CreateNotifications,
    CreateTemplate,
  },
  created() {
    this.$store.dispatch('GET_TEMPLATES_LIST');
  },
  data() {
    return {
      settings: {
        sms: {
          planned_at: new Date(),
          source: null,
          notification_template: {
              name: '',
          },
          is_default_account: true,
        },
        call: {
          planned_at: new Date(),
          source: null,
          notification_template: {
              name: '',
          },
          is_default_account: true,
        },
      },
      selectable: true,
      props: {},
    };
  },
  computed: {
    templates() {
        return this.$store.getters.TEMPLATES_LIST.results;
    },
  },
  methods: {
    createModal(channel) {
      if (
        this.settings[channel].notification_template
      ) {
        this.props = {
          channel,
          settings: this.settings[channel],
          user: this.authUser,
          id: null,
        };
        this.$store.dispatch("USER_MODALS", true);
      }
    },
    createMessageTemplate() {
        this.$store.dispatch("CREATE_TEMPLATE_MODAL", true);
    },
    filteredDataArray(data, item, type) {
        return data.filter((option) => {
          return option.name
              .toString()
              .toLowerCase()
              .indexOf(item.name.toLowerCase()) >= 0 && (type ? option.type === type : 1)
        })
    },
    filteredNewDataArray(data, item, type_of_notification) {
        return data.filter((option) => {
          return option.name
              .toString()
              .toLowerCase()
              .indexOf(item.name.toLowerCase()) >= 0 && option.type_of_notification === type_of_notification && option.is_used;
        });
    },
  },
};
</script>

<style>
.tabs.is-toggle li.is-active a {
  background-color: #1d8f68;
}
.element-bg-cyan.is-primary {
  background-color: #1d8f68;
}
</style>
